<template>
  <div class="div-main flex-col">
    <div class="top">
      <img class="img-back"
        src="/src/assets/imgs/back.png"
        alt=""
        @click="back" />
    </div>
    <div class="org-info">
      <div class="org-logo">
        <div class="title">
          <span>{{data.name}} </span>
        </div>
        <span v-if="!isMarked"
          class="mark not-marked"
          @click="mark">
          + 收藏
        </span>
        <span v-if="isMarked"
          class="mark marked"
          @click="mark">
          已收藏
        </span>
      </div>

      <div class="org-prefer">
        <span>{{ data.companyName }}</span><span v-if="data.position!=null"> </span>
        <span>{{data.position}}</span>
        <!-- <van-icon name="arrow"
          class="go-right"
          size="1.4rem" /> -->
      </div>
    </div>
    <div class="content"
      ref="container">

      <div class="description"
        ref="container">
        <div class="description-title">
          人物简介
        </div>
        <div class="description-main">
          {{data.description}}
        </div>
      </div>

      <div class="content"
        ref="container">
        <div class="cont-title">
          关联<span style="color:#c52a1a;">{{ pwcList.length }}</span>条PwC关系
        </div>
        <div class="cont-main">
          <van-list v-model="loading"
            :finished="finished"
            finished-text=""
            @load="onLoad">
            <div class="items"
              v-for="user in pwcList"
              :key="user.id">
              <div class="dot-div">
                <div class="dot"></div>
              </div>
              <div class="item-img">
                <van-image width="2rem"
                  height="2.5rem"
                  :src="user.photoBase64" />
              </div>
              <div class="item-info">
                <div class="item-head">
                  <div class="head-name">
                    <span>{{ user.englishName }}</span>
                    <span> 关系深度：{{user.relationDeepthName}}</span>
                  </div>
                </div>
                <div class="item-position">
                  <span v-text="user.los"></span>
                  <span class="item-position-sep">/</span>
                  <span v-text="user.city"></span>
                  <span class="item-position-sep">/</span>
                  <span v-text="user.jobTitle"></span>
                  <span class="item-position-sep"
                    v-if="user.officeTel != null ">/ Ext.{{user.officeTel}}</span>
                </div>
                <div v-if="user.canMark"
                  class="mark-icon"
                  @click="markRel(user)">
                  <i class="iconfont iconRa1ting"
                    style="color:#d04a02"
                    v-if="user.isMarked"></i>
                  <i class="iconfont iconRating1"
                    v-else></i>
                </div>
              </div>
              <div class="item-email">
                <a :href="['mailto:' + user.email]"
                  style="color: #2d2d2d;">
                  <span class="icon iconfont iconemail-outline"></span>
                </a>
              </div>
              <!-- <div class="item-phone">
                <span class="icon iconfont iconcall-outline"></span>
              </div> -->
            </div>
          </van-list>
        </div>
      </div>

      <div class="comment">
        <div class="comment-head">
          <div class="comment-title">评论</div>
          <div class="add-comment"
            @click="showComment">
            <span class="icon iconfont iconcomment-outline"> 我要评论 </span>
          </div>
        </div>
        <van-list :finished="finished"
          finished-text="没有更多了">
          <div v-for="comment in commentsList"
            :key="comment.id"
            class="comment-item">
            <div class="user-avatar">
              <van-image :src="comment.photoBase64" />
            </div>
            <div class="comment-cont">
              <div class="commnet-info">
                <span class="name">{{ comment.englishName }}</span>
                <span class="date">{{ comment.createTime }}</span>
              </div>
              <div class="cont">
                {{ comment.content }}
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
    <div class="know-him-button-container"
      v-if="!data.isAddRelation">
      <div class="know-him-button-button"
        @click="goToAddRelationshipPage()">
        我认识他/她
      </div>
    </div>

    <div class="know-him-button-container"
      v-if="data.isAddRelation && editId != null ">
      <div class="know-him-button-button"
        @click="goToEidtRelationshipPage()">
        编辑
      </div>
    </div>

    <van-popup v-model="show"
      position="bottom"
      :style="{ height: '30%' }">
      <form action=""
        class="comment-info">
        <van-field v-model="message"
          style="background-color: #ebeaea;"
          rows="8"
          autosize
          type="textarea"
          placeholder="请输入评论" />
        <div class="send-button"
          @click="comment($event)">发送</div>
      </form>
    </van-popup>
  </div>
</template>
<script>
import common from "@common/common";
import webService from "@network/webService";
import store from "@common/store";

export default {
  data () {
    return {
      isMarked: false,
      buttonDisabled: false,
      container: null,
      loading: false,
      finished: false,
      pwcList: [],
      commentsList: [],
      data: {},
      show: false,
      message: "",
      editId: null,
    };
  },
  components: {},
  computed: {},
  mounted () {
    this.container = this.$refs.container;
    var id = this.$route.query.id;
    this.editId = this.$route.query.editId;

    this.$bus.$on("busfreshContact", ({ id }) => {
      console.log(this.$route.query.id);
      this.getDetail(id);
    });


    this.getDetail(id);
    this.getComments();
    common.addViewHistory(
      this.$route.query.id,
      common.favoriteTypeEnum.CompanyContact
    );
  },
  methods: {
    getDetail (id) {

      webService.getInvestedCompanyContactDetails(id).then((res) => {
        console.log(res.data);
        this.data = res.data;
        this.isMarked = res.data.marked;
        if (
          this.data &&
          (this.data.photo == undefined || this.data.photo == "")
        ) {
          this.data.photo = require("@assets/imgs/contactor.png");
        }
      });

      var relationshipFilters = {};
      relationshipFilters.id = id;
      relationshipFilters.deepthIds = store.state.filter.companyRelatiohshipDeepthIds;
      webService.getInvestedCompanyContactRelationships(relationshipFilters).then((res) => {
        this.pwcList = res.data;
        console.log(this.pwcList);
      });
    },
    markRel (item) {
      let dto = {
        RelationshipId: item.id,
        FavoriteType: common.favoriteTypeEnum.CompanyContact,
        IsCancel: item.isMarked,
      };
      webService.addFavoriteRelationship(dto).then((res) => {
        console.log(res);
        if (res.data && res.data.success) {
          item.isMarked = !item.isMarked;
          let msg = item.isMarked ? "已收藏" : "取消收藏";
          this.$toast.success(msg);
        } else {
          Toast.fail(res.data.message);
        }
      });
    },
    getComments () {
      let id = this.$route.query.id;
      webService.getComments(id).then((res) => {
        this.commentsList = res.data.data;
        this.commentsList.forEach((item) => {
          item.createTime = this.$moment(item.createTime).format(
            "yyyy-MM-DD HH:mm"
          );
        });
      });
    },
    justToAddRelationshipPage () {
      this.$router.push({
        path: "/home/addRelationship",
        query: {
          id: this.$route.query.id,
        },
      });
    },
    goToAddRelationshipPage () {
      var id = this.$route.query.id;
      this.$router.push({
        path: "/home/addRelationship",
        query: {
          id: id,
          type: "company",
        },
      });
    },
    goToEidtRelationshipPage () {
      var id = this.$route.query.id;
      this.$router.push({
        path: "/home/addRelationship",
        query: {
          relationshipId: id,
          type: "company",
        },
      });
    },
    back () {
      this.$router.go(-1);
    },
    onLoad () {
      // 加载状态结束
      this.loading = false;
      // 数据全部加载完成
      this.finished = true;
    },
    mark () {
      console.log(this.data);
      common.mark(
        this,
        this.data.id,
        common.favoriteTypeEnum.CompanyContact,
        this.isMarked
      );
    },
    showComment () {
      this.message = "";
      this.show = true;
    },
    comment (e) {
      //if (e.keyCode === 13) {
      //e.preventDefault();
      if (
        this.message == null ||
        this.message == undefined ||
        this.message.trim() == ""
      ) {
        this.$toast.fail(this.$t("notEmptyComment"));
        return;
      }
      let dto = {
        RelationID: this.$route.query.id,
        Content: this.message,
      };
      webService.addComment(dto).then((res) => {
        console.log(res);
        if (res.data.success) {
          this.getComments();
          this.$toast.success("评论成功");
          this.show = false;
        } else {
          this.$toast.fail("发生异常错误");
        }
      });
      //}
    },
    formatDate (date) {
      if (date) {
        return this.$moment(date).format("yyyy/MM/DD");
      } else {
        return "";
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.div-main {
  height: 100%;
}
.top {
  padding: 10px;
  background-color: #d04a02;
  height: 35px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  img {
    width: 4.375rem;
    height: 4.375rem;
  }
  .img-back {
    width: 2.5rem;
    height: 2.5rem;
  }
}
.org-info {
  padding: 0.625rem;
  border-bottom: 6px solid #f2f2f2;
  // height: 7.5rem;
  flex-shrink: 0;
  .org-logo {
    height: 2.5rem;
    position: relative;
    // .img-avater {
    //     position: absolute;
    //     top: -2.5rem;
    //     width: 5rem;
    //     height: 5rem;
    // }
    .img-logo {
      position: absolute;
      top: -2.5rem;
      height: 4.375rem;
      width: 4.375rem;
    }
    // .mark {
    //   position: absolute;
    //   right: 0;
    //   bottom: 0;
    //   padding: 2px;
    //   border: 1px solid #eb8c00;
    //   color: #eb8c00;
    //   padding: 0.375rem 0.875rem;
    //   text-align: center;
    // }
  }
  .title {
    font-size: 1.625rem;
    font-weight: bolder;
    color: #464646;
  }

  .title2 {
    font-size: 1rem;
    font-weight: 400;
    color: #464646;
  }
  .org-prefer {
    padding: 0.625rem 0;
    color: #7f7f7f;
    span {
      font-size: 0.875rem;
    }
    .go-right {
      float: right;
    }
  }
}

.description {
  flex: 1;
  overflow: auto;
  position: relative; //   height: calc(100%-1.25rem);
  border-bottom: 6px solid #f2f2f2;
  padding: 0.6rem;
  margin-bottom: 0.2rem;
  font-family: PingFangSC-Semibold;
  .description-title {
    font-weight: bolder;
    font-size: 1rem;
    padding-left: 0.1rem;
    height: 2.8rem;
    line-height: 2.8rem;
    color: #464646;
  }
  .description-main {
    font-weight: 400;
    font-size: 1rem;
    padding-left: 0.1rem;
    padding-right: 0.5rem;
    line-height: 1.8rem;
    color: #464646;
  }
}

.content {
  flex: 1;
  overflow: auto;
  position: relative; //   height: calc(100%-1.25rem);
  .cont-title {
    font-family: PingFangSC-Semibold;
    font-weight: bolder;
    font-size: 1rem;
    padding-left: 0.625rem;
    height: 2.8rem;
    line-height: 2.8rem;
    color: #464646;
  }
  .cont-main {
    height: calc(100% - 2.9rem);
    overflow: auto; // padding-bottom: 0.625rem;
  }
  .items {
    display: flex;
    padding: 0.375rem;
    width: 22rem;
    .dot-div {
      display: flex;
      align-items: center;
      padding: 0.5rem;
      .dot {
        width: 0.625rem;
        height: 0.625rem;
        background-color: #dedede;
        border-radius: 50%;
      }
    } // border-bottom: 0.375rem solid #f2f2f2;
    .item-img {
      padding: 0.5rem 0.25rem;
    }
    .item-info {
      padding: 0.5rem 0.25rem;
      flex: 1;
      position: relative;
      .item-head {
        display: flex;
        .head-name {
          color: #3d3d3d;
          font-size: 0.875rem;
        }
      }
      .item-prefer,
      .item-position {
        padding: 0.25rem 0;
        color: #7d7d7d;
        font-size: 0.75rem;
        padding-bottom: 2px;
        //word-break: keep-all;
      }
      .mark-icon {
        position: absolute;
        font-size: 12px;
        top: 25%;
        // transform: translateY(50%);
        right: 10px;
      }
      .items {
        display: flex;
        padding: 0.375rem;
        .dot-div {
          display: flex;
          align-items: center;
          padding: 0.5rem;
          .dot {
            width: 0.625rem;
            height: 0.625rem;
            background-color: #dedede;
            border-radius: 50%;
          }
        } // border-bottom: 0.375rem solid #f2f2f2;
        .item-img {
          padding: 0.5rem 0.25rem;
        }
        .item-info {
          padding: 0.5rem 0.25rem;
          flex: 1;
          .item-head {
            display: flex;
            .head-name {
              color: #3d3d3d;
              font-size: 0.875rem;
              width: 70%;
            }
          }
          .item-prefer,
          .item-position {
            padding: 0.25rem 0;
            color: #c7b6b6;
            font-size: 0.75rem;
            padding-bottom: 2px;
            //word-break: keep-all;
          }

          .item-position-sep {
            margin: 5px 0px;
          }
        }
      }
    }
    .item-email {
      margin-left: 0;
      margin-top: 1rem;
    }
    .item-phone {
      margin-left: 2rem;
      margin-top: 1rem;

      a {
        color: #2d2d2d;
      }
    }
  }
}
.comment {
  border-top: 8px solid #f2f2f2;
  padding: 0.75rem 0.75rem;
  .comment-head {
    padding: 0.75rem 0rem;
    display: flex;
    .comment-title {
      font-size: 16px;
      font-weight: bold;
    }
    .add-comment {
      flex: 1;
      text-align: right;
      font-size: 16px;
      float: right;
      color: #c52a1a;
      i {
        font-size: 12px;
      }
    }
  }
  .comment-item {
    display: flex;
    margin-bottom: 1rem;
    .user-avatar {
      width: 3.125rem;
      height: 3.125rem;
      text-align: center;
    }
    .comment-cont {
      padding-left: 0.6rem;
      flex: 1;
      .commnet-info {
        .date {
          float: right;
          font-size: 12px;
          line-height: 16px;
          letter-spacing: 1px;
          color: #7d7d7d;
        }
      }
      .cont {
        padding-top: 0.375rem;
        font-size: 16px;
        line-height: 20px; // letter-spacing: 1px;
        color: #7d7d7d;
      }
    }
  }
}
.know-him-button-container {
  border-top: 1px solid #ededed;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
}
.know-him-button-button {
  width: 60%;
  border: 1px solid #c52a1a;
  text-align: center;
  padding: 10px 20px;
  color: #c52a1a;
}
.btn-submit {
  background-color: #d04a02;
  border: none;
}
.comment-info {
  padding: 20px 0 20px 20px;
  background-color: white;
  display: flex;
  flex-direction: row;
}
.send-button {
  width: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #e0301e;
}
</style>


// WEBPACK FOOTER //
// src/components/content/contractor/ContractorDetailCompany.vue